<template>
    <div>
        <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
                <div>
                    <div class="file-upload-form">
                        <!--<label class="required">Добавьте изображение:</label>-->

                        <input type="file" ref="inputFile" class="hidden" @change="previewImage" accept="image/*" />
                    </div>

                    <div v-if="uploaded && !loaded && uploaded.data1 && uploaded.data1.length > 0" class="mb-4 mr-2">
                        <img class="image-preview" :src="uploaded.data1" width="246" />
                    </div>
                    <div v-if="uploaded && !loaded && uploaded.data2 && uploaded.data2.length > 0" class="mb-4 mr-2">
                        <img class="image-preview" :src="uploaded.data2" width="150" />
                    </div>

                    <div v-if="image && loaded && image.data1.length > 0" class="mb-4 mr-2">
                        <img class="image-preview" :src="image.data1" width="246" />
                    </div>
                    <div v-if="image && loaded && image.data2.length > 0" class="mb-4 mr-2">
                        <img class="image-preview" :src="image.data2" width="150" />
                    </div>

                    <!-- <div>
                        <small>Допустим формат jpeg, разрешение 300x300 или 492x328</small>
                    </div> -->
                    <vs-button class="mt-5 mr-2" color="warning" @click="addImage()" type="filled"> Загрузить </vs-button>
                </div>
            </div>
        </div>

        <sweet-modal blocking ref="cropperModal" title="Добавление изображения" width="50%" style="z-index: 100000 !important">
            <div style="max-height: calc(100vh - 300px); overflow-y: auto; overflow-x: hidden">
                <div class="vx-row mb-2">
                    <div class="vx-col w-1/2 cropperOuter">
                        <div class="vx-row">
                            <div class="cropper">
                                <vue-cropper
                                    ref="cropper1"
                                    :aspect-ratio="1.5"
                                    :src="imgSrc"
                                    preview=".preview"
                                    :zoomable="false"
                                    :movable="false"
                                    :rotatable="false"
                                    :scalable="false"
                                />
                            </div>
                        </div>
                        <div class="vx-row ml-5">
                            <span class="bld mt-1 ml-5">(492x328)</span>
                        </div>
                    </div>

                    <div class="vx-col w-1/2 cropperOuter">
                        <div class="vx-row">
                            <div class="cropper">
                                <vue-cropper
                                    ref="cropper2"
                                    :aspect-ratio="1"
                                    :src="imgSrc"
                                    preview=".preview"
                                    :zoomable="false"
                                    :movable="false"
                                    :rotatable="false"
                                    :scalable="false"
                                />
                            </div>
                        </div>
                        <div class="vx-row ml-5">
                            <span class="bld mt-1 ml-5">(300x300)</span>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <vs-button class="modalButton ml-5" color="warning" @click="cancel()" type="filled"> Отмена </vs-button>
                <vs-button class="modalButton ml-5" color="primary" @click="resizeImage()" type="filled"> ОК </vs-button>
            </div>
        </sweet-modal>
    </div>
</template>

<script>
import { SweetModal, SweetModalTab } from 'sweet-modal-vue';
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';

export default {
    props: {
        uploaded: {},
        campaignId: undefined
    },
    data() {
        return {
            imgSrc: '',
            image: {
                name: '',
                type: '',
                imageTypeId: 1,
                data1: '',
                width1: 0,
                height1: 0,
                data2: '',
                width2: 0,
                height2: 0
            },
            loaded: false
        };
    },
    components: {
        SweetModal,
        SweetModalTab,
        VueCropper
    },

    methods: {
        cancel() {
            this.$refs.cropperModal.close();
        },
        addImage() {
            if (this.image) {
                if (this.image.width == 492 && this.image.height == 328) {
                    this.aspectr = 1.5;
                    console.log(this.aspectr);
                }
                if (this.image.width == 300 && this.image.height == 300) {
                    this.aspectr = 1;
                }
            }

            this.$refs.inputFile.click();
        },
        clearImage() {
            this.$refs.inputFile.value = '';
        },
        async previewImage(event) {
            var input = event.target;
            if (input.files && input.files[0]) {
                var reader = new FileReader();
                const file = input.files[0];

                if (file.type.indexOf('image/') === -1) {
                    return;
                }

                var compareResult = await this.compareImage(file);
                if (compareResult.isSimilar) {
                    this.clearImage();
                    return this.$vs.notify({
                        title: 'Внимание!',
                        text: 'Есть похожие картинки, выберите другую.',
                        color: 'warning'
                    });
                }

                if (compareResult.hasErrors) {
                    this.clearImage();
                    return this.$vs.notify({
                        title: 'Внимание!',
                        text: 'Ошибка при сравненни картинок!',
                        color: 'danger'
                    });
                }

                this.$refs.cropperModal.open();
                reader.onload = (e) => {
                    this.imgSrc = e.target.result;
                    this.$refs.cropper1.replace(this.imgSrc);
                    this.$refs.cropper2.replace(this.imgSrc);
                };
                reader.readAsDataURL(file);
                this.clearImage();
            }
        },

        async compareImage(image) {
            let formData = new FormData();
            formData.append('file', image);

            var result = await this.axios
                .post(`image-compare/targets?campaignId=${this.campaignId}`, formData, {})
                .then((response) => {
                    return { 
                        isSimilar : response.data.isSimilar, 
                        hasErrors: false 
                    };
                })
                .catch((err) => {
                    return { 
                        isSimilar : false, 
                        hasErrors: true
                    };
                });

            return result;
        },

        resizeImage() {
            let cropImg1 = this.$refs.cropper1.getCroppedCanvas().toDataURL();
            let cropImg2 = this.$refs.cropper2.getCroppedCanvas().toDataURL();

            this.image.id = 0;
            this.image.name = '0f1afea9-5bd9-4e21-87ee-4af98cc4d949.jpg';
            this.image.type = 'image/jpeg';
            this.image.width1 = 492;
            this.image.height1 = 328;
            this.image.width2 = 300;
            this.image.height2 = 300;

            const canvas1 = document.createElement('canvas');
            const canvas2 = document.createElement('canvas');
            canvas1.width = 492;
            canvas1.height = 328;
            canvas2.width = 300;
            canvas2.height = 300;
            const ctx1 = canvas1.getContext('2d');
            const ctx2 = canvas2.getContext('2d');

            const img1 = new Image();
            const img2 = new Image();
            img1.src = cropImg1;
            img2.src = cropImg2;

            img1.onload = () => {
                ctx1.drawImage(img1, 0, 0, 492, 328);
                this.image.data1 = canvas1.toDataURL('image/jpeg', 0.8);
            };

            img2.onload = () => {
                ctx2.drawImage(img2, 0, 0, 300, 300);
                this.image.data2 = canvas2.toDataURL('image/jpeg', 0.8);
            };

            this.$refs.cropperModal.close();

            this.selectImage();
        },

        selectImage() {
            this.loaded = true;
            
            this.$emit("selectImage", this.image);
        },

        reset() {
            this.image.id = 0;
            this.image.name = '0f1afea9-5bd9-4e21-87ee-4af98cc4d949.jpg';
            this.image.type = 'image/jpeg';
            this.image.width1 = 492;
            this.image.height1 = 328;
            this.image.width2 = 300;
            this.image.height2 = 300;
            this.image.data1 = '';
            this.image.data2 = '';
        }
    },
    watch: {},
    computed: {
    },
    mounted() {
    }
};
</script>

<style lang="scss">
.image-preview {
    border-style: solid;
    border-color: green;
    border-radius: 10px;
    padding: 5px;
}

.cropper {
    display: inline-block;
    height: 80%;
    margin-left: 30px;
    margin-right: 30px;
}

.cropperOuter {
    width: 100%;
    text-align: center;
}

.modalButton {
    float: right;
}

.preview {
    width: 100%;
    height: calc(372px * (9 / 16));
    overflow: hidden;
}
</style>
